import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationRoadSurfacePluginService } from './road-surface.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ModalComponent } from '../../../modal/modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'installation-road-surface-edit',
    templateUrl: './road-surface-edit.component.html',
    standalone: false
})
export class InstallationRoadSurfaceEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;
  surfaceTypes: any[];

  @ViewChild('surfaceTypesModal', { static: true }) surfaceTypesModal: ModalComponent;

  private sub = new Subscription();

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationRoadSurfacePluginService
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateRoadSurface(this.inspectionId, this.pointId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public onClose(e: any) {
    this.editForm.controls['surfaceType'].markAsTouched();
  }

  public openRoadSurfaceSelector() {
    this.openSelector(this.surfaceTypesModal, this.surfaceTypes, this.editForm.controls.surfaceType.value);
  }

  public selectRoadSurfaceMenu(item: any) {
    const selectedIndex = this.editForm.controls.surfaceType.value === item.selectedIndex ? '' : item.selectedIndex;
    this.editForm.controls.surfaceType.setValue(selectedIndex);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.surfaceTypes = this.pluginService.getSurfaceTypes();
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = new UntypedFormGroup({
      label: new UntypedFormControl(this.plugin.config.Label ?? ''),
      surfaceType: new UntypedFormControl(
        this.plugin.config.SurfaceType ? parseInt(this.plugin.config.SurfaceType) : ''
      )
    });
  }
}
